export default __webpack_public_path__ + "static/media/easyjobs-icon-blue.3f0b3e23.svg";